export interface TypeHabit {
  id: string;
  nom: string;
  icon: string;
  description: string;
}

export const typesHabitMock: TypeHabit[] = [
  { id: 'th1', nom: 'Boubou', icon: 'ri-user-3-line', description: 'Grand boubou traditionnel' },
  { id: 'th2', nom: 'Robe', icon: 'ri-women-line', description: 'Robe simple ou élaborée' },
  { id: 'th3', nom: 'Kaftan', icon: 'ri-user-star-line', description: 'Kaftan brodé ou uni' },
  { id: 'th4', nom: 'Ensemble 2 pièces', icon: 'ri-layout-2-line', description: 'Haut + jupe ou pantalon' },
  { id: 'th5', nom: 'Complet Homme', icon: 'ri-men-line', description: 'Complet traditionnel homme' },
  { id: 'th6', nom: 'Tenue Cérémonie', icon: 'ri-award-line', description: 'Tenue formelle ou mariage' },
  { id: 'th7', nom: 'Chemise / Haut', icon: 'ri-shirt-line', description: 'Pièce du haut simple' },
  { id: 'th8', nom: 'Jupe / Pagne', icon: 'ri-women-line', description: 'Jupe ou pagne simple' },
];
